<template>
    <!--          <el-tabs>-->
    <!--            <el-tab-pane class="tab_style" :key="1" label="基本信息">-->
    <div>
      <el-form :model="temp" label-width="160px"  size="mini" ref="temp" style="margin-top:5px">
        <el-row :gutter="80">
          <el-col :span="11">
            <el-tooltip placement="top" content='' effect="light">
              <div slot="content">{{temp.venderName}}</div>
              <el-form-item label="供应商名称：" prop="venderName">
                <el-input :disabled="!showEditButton" v-model="temp.venderName"/>
              </el-form-item>
            </el-tooltip>
          </el-col>
          <el-col :span="11">
            <el-tooltip placement="top" content='' effect="light">
              <div slot="content">{{temp.venderAdd}}</div>
              <el-form-item label="供应商地址：" prop="venderAdd">
                <el-input disabled v-model="temp.venderAdd"/>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row :gutter="80">
          <el-col :span="11">
            <div slot="content">{{temp.isPru}}</div>
            <el-form-item label="生产供应商：" prop="isPru" >
              {{ temp.isPru === 1 ? '是' : '否' }}
              <!--                            <el-checkbox v-model="temp.isPru" :true-label=1 :false-label=0 :disabled="!showEditButton"></el-checkbox>-->
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <div slot="content">{{temp.isGen}}</div>
            <el-form-item label="综合供应商：" prop="isGen">
              {{ temp.isGen === 1 ? '是' : '否' }}
              <!--                            <el-checkbox v-model="temp.isGen" :true-label=1 :false-label=0 :disabled="!showEditButton"></el-checkbox>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="80">
          <el-col :span="11">
            <div slot="content">{{temp.supcompanyCode}}</div>
            <el-form-item label="子公司代码：" prop="supcompanyCode" >
              <el-input disabled v-model="temp.supcompanyCode"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <div slot="content">{{temp.supgroupCode}}</div>
            <el-form-item label="采购组代码：" prop="supgroupCode">
              <el-input disabled v-model="temp.supgroupCode"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="80">
          <el-col :span="11">
            <div slot="content">{{temp.venderType}}</div>
            <el-form-item label="企业类型：" prop="venderType" >
              <el-input disabled v-model="temp.venderType"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <div slot="content">{{temp.venturePartner}}</div>
            <el-form-item label="主要合资方：" prop="venturePartner">
              <el-input disabled v-model="temp.venturePartner"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="80">
          <el-col :span="11">
            <div slot="content">{{temp.empNum}}</div>
            <el-form-item label="公司人数：" prop="empNum" >
              <el-input disabled v-model="temp.empNum"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <div slot="content">{{temp.venderEdge}}</div>
            <el-form-item label="企业经营范围：" prop="venderEdge">
              <el-input disabled v-model="temp.venderEdge"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="80">
          <el-col :span="11">
            <el-form-item label="联系人：" prop="venderContacts">
              <el-input disabled v-model="temp.venderContacts"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="联系电话：" prop="venderTel">
              <el-input disabled v-model="temp.venderTel"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="80">
          <el-col :span="11">
            <el-form-item label="传真：" prop="venderFax">
              <el-input disabled v-model="temp.venderMail"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="e-mail：" prop="venderMail">
              <el-input disabled v-model="temp.venderMail"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="80">
          <el-col :span="11">
            <el-form-item label="归属平台：" prop="productName">
              <el-input disabled v-model="temp.productName"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="审核结论：" prop="approveIssue">
              <el-input type="textarea" disabled v-model="temp.approveIssue"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="80">
          <el-col :span="11">
            <el-form-item label="审核得分：" prop="approveStore">
              <el-input disabled v-model="temp.approveStore"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="审核等级：" prop="approveClass">
              <el-input disabled v-model="temp.approveClass"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="80">
          <el-col :span="11">
            <el-form-item label="邀请状态：" prop="inviteStauts">
              <el-select v-model="temp.inviteStauts" clearable placeholder="请选择" disabled>
                <el-option v-for="item in options1" :key="item.value" :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="创建时间：" prop="createTime">
              <el-input disabled v-model="temp.createTime"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="80">
          <el-col :span="11">
            <el-form-item label="审批单编号:" prop="approvalNo">
              <el-input disabled v-model="temp.approvalNo"/>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="是否免审:" prop="isExempt">
              {{ temp.isExempt === 'Y' ? '是' : '否' }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    <!--            </el-tab-pane>-->
    <!--            <el-tab-pane class="tab_style" :key="2" label="附件文件">-->
    <FileUpDown ref="FileUpDown" :bizId="venderinviteId" :bizType="FILE_BIZ_TYPE" :viewFlag="'view'" :canDelete="false"></FileUpDown>
    <!--            </el-tab-pane>-->

    </div>

</template>

<script>
import FileUpDown from "../../../common/file-up-down.vue";
export default {
  components:{FileUpDown},
  name:'SupplierInquiryView',
  props: {
    venderinviteId: Number,
    showEditButton:Boolean,
    temp:{
      venderName : '',
      venderAdd : '',
      isPru:'',
      isGen:'',
      supcompanyCode:'',
      supgroupCode:'',
      venderType:'',
      venturePartner:'',
      empNum:'',
      venderEdge:'',
      venderContacts : '',
      venderTel : '',
      venderMail : '',
      productName:'',
      approveIssue:'',
      approveStore:'',
      approveClass:'',
      inviteStauts:'',
      createTime:'',
      isExempt:'',
      approvalNo:'',
    },
  },
  data(){
    return{
      dialogVisible: false,
      options1: [{
        value: 0,
        label: '未邀请'
      }, {
        value: 1,
        label: '已邀请'
      }
      ],

      FILE_BIZ_TYPE:30,

    }
  },
  watch: {
    venderinviteId: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal && this.$refs.FileUpDown) {
          // 当venderinviteId变化时，刷新文件列表
          console.log('venderinviteId变化，新值:', newVal, '旧值:', oldVal);
          this.$nextTick(() => {
            // 调用FileUpDown组件的init方法重新初始化，这会重新获取文件列表
            this.$refs.FileUpDown.init('view');
          });
        }
      },
      immediate: false
    }
  },
  methods:{
    getData(row){
      return this.temp
      // this.temp = Object.assign({}, row) // copy obj
      // this.venderinviteId = row.id
      console.log('d',this.venderinviteId)
    }
  }

}
</script>